import { ReactComponent as SearchSVG } from "assets/media/svg/icons/General/Search.svg";
import React from "react";

export default function Search({ value, setValue }) {
  return (
    <div className="input-icon d-none d-sm-block search-container">
      <input
        type="text"
        className="form-control form-control-lg form-control-solid h-49px search-input"
        placeholder="Search"
        id="generalSearch"
        autoComplete="false"
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      />
      <span>
        <span className="svg-icon svg-icon-lg">
          <SearchSVG />
        </span>
      </span>
    </div>
  );
}
